export default {"src":"/_next/static/media/outrun_.3ed17b42.svg","height":52,"width":60};